import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit';

import Card from 'components/Account/Common/Card/Card';
import Trans from 'components/Common/Translation/Trans';
import { useCustomer } from 'hooks/useCustomer';
import { getRoutesUri } from 'services/generic';
import { SMALL_DESKTOP } from 'settings/mediaQuery';

import styles from './Identifier.module.scss';

function Identifier(): JSX.Element {
  const { t } = useTranslation(['personalDetailsPage']);
  const { customer } = useCustomer();
  const isSmallDesktop = useMediaQuery({
    query: SMALL_DESKTOP,
  });

  return (
    <Card classes={{ container: styles.identifierBlock }}>
      <div className={styles.title}>
        <label>{t('LABEL_PAGE_TITLE')}</label>
      </div>
      <div className={styles.identifierContent}>
        <div className={styles.emailBlock}>
          <label className={styles.emailLabel}>
            <Trans i18nKey={'LABEL_EMAIL'} namespace={'personalDetailsPage'} />
          </label>
          <label className={styles.emailContent}>{customer?.email}</label>
          <label className={styles.editLink}>
            <a
              href={
                getRoutesUri('customerAccountInformationEditEmail') as string
              }
            >
              <FontAwesomeIcon icon={faEdit} />
              {!isSmallDesktop
                ? t('LABEL_EDIT_EMAIL')
                : t('LABEL_EDIT_EMAIL_MOBILE')}
            </a>
          </label>
        </div>
        <div className={styles.passwordBlock}>
          <label className={styles.passwordLabel}>
            <Trans
              i18nKey={'LABEL_PASSWORD'}
              namespace={'personalDetailsPage'}
            />
          </label>
          <label className={styles.passwordContent}>**********</label>
          <label className={styles.editLink}>
            <a
              href={
                getRoutesUri('customerAccountInformationEditPassword') as string
              }
            >
              <FontAwesomeIcon icon={faEdit} />
              {!isSmallDesktop
                ? t('LABEL_EDIT_PASSWORD')
                : t('LABEL_EDIT_PASSWORD_MOBILE')}
            </a>
          </label>
        </div>
      </div>
    </Card>
  );
}

export default Identifier;
